export default __webpack_public_path__ + "static/media/goals.cbe4768a.png";